import {
  MISC_INIT_DATA,
  MISC_CONNECTION_ENABLED,
  MISC_CONNECTION_DISABLED,
} from '@/store/action_types/misc';

import type { App } from 'vue';
import eventBus from '@/setup/eventBus';
import store from '@/store';

// Refactoring position calculate for vue-progressbar
// See more: https://bwaffiliates.atlassian.net/secure/RapidBoard.jspa?rapidView=26&projectKey=ACTECH&modal=detail&selectedIssue=ACTECH-3

export default (app: App<Element>) => {
  const { $Progress } = app.config.globalProperties;
  let requestsCount = 0;
  const errorsPull = [];

  eventBus.$on('request-start', () => {
    if (requestsCount === 0) {
      $Progress.start();
    }
    requestsCount += 1;
  });

  eventBus.$on('request-fail', (error: any) => {
    $Progress.fail();
    requestsCount -= 1;
    if (requestsCount > 0) {
      $Progress.start();
    }
    errorsPull.push(error);
  });

  eventBus.$on('response-error', (error: any) => {
    $Progress.fail();
    requestsCount -= 1;
    if (requestsCount > 0) {
      $Progress.start();
    }
    errorsPull.push(error);
  });

  eventBus.$on('response-success', () => {
    requestsCount -= 1;
    if (requestsCount === 0) {
      $Progress.finish();
    }
  });

  eventBus.$on('connection-enabled', () => {
    if (!store.getters['misc/countersEnabled']) {
      store.dispatch(`misc/${MISC_INIT_DATA}`);
    }
    store.commit(`misc/${MISC_CONNECTION_ENABLED}`);
  });

  eventBus.$on('connection-lost', () => {
    store.commit(`misc/${MISC_CONNECTION_DISABLED}`);
  });
};
